// src/task/TaskRequestMonthRecords.ts

// 任务类: 请求一个月每日记录概览。

import axios from 'axios'
import { CalendarApi } from '../services/Api';
import { ROLE } from "../services/Macro";
import { encrypUtil } from "../utils/EncrypUtil";
import { strUtil } from "../utils/StrUtil";
import { timeUtil } from '../utils/TimeUtil';
import { Task } from "./Tast";

export class TaskRequestMonthRecords implements Task {

    isStart: boolean = false
    isEnd: boolean = false
    year: number = 0
    month: number = 0
    setRecordMap: Function | undefined = undefined

    async start(): Promise<void> {
        this.isStart = true
        this.excute()
    }

    async stop(): Promise<boolean> {
        this.isStart = false
        while (!this.isEnd) {
            await timeUtil.sleep(50)
        }
        return this.isEnd
    }

    async excute() {
        const DEBUG = false
        const TAG = `TaskRequestMonthRecords.excute() - `
        let dayCountPerMonth = 31
        let count = 1
        let map = new Map()
        while (this.isStart && count <= dayCountPerMonth) {
            const uuid = 'system'
            let token = localStorage.getItem('token') || null
            let lang = localStorage.getItem('lang') || 'zh_CN'
            let dayStr = strUtil.fillPrev(`${count}`, 2, '0')
            let monthStr = strUtil.fillPrev(`${this.month}`, 2, '0')
            let date = `${this.year}-${monthStr}-${dayStr}`
            // 请求页面数据
            let requestData = {
                role: ROLE.SUPER,
                token: token,
                // uuid: uuid,
                lang: lang.split('_')[0],
                page: 1,
                size: 3,
                date: date
            }
            // DEBUG && console.log(TAG, `requestData:\n`, requestData)
            let params = await encrypUtil.encodeRequestRsa(requestData)
            // DEBUG && console.log(TAG, `params:\n`, params)
            const response = await axios.post(CalendarApi.GET_RECORD_LIST_BY_DATE, params)
            if (this.isStart && response && response.data && response.data.data && response.data.data.count > 0) {
                DEBUG && console.log(TAG, `response.data:\n`, response.data.data)
                let recordList: { time: string, name: string, age: number, gender: number }[] = []
                let showData = {
                    count: response.data.data.count,
                    recordList: recordList,
                }
                for (let i = 0; i < response.data.data.list.length; i++) {
                    let record = response.data.data.list[i]
                    let name = record.meta.name ? record.meta.name : 'unknown'
                    showData.recordList.push({
                        time: timeUtil.getMonthDayFromTimestamp(record.create),
                        name: name,
                        age: record.age,
                        gender: record.gemder,
                    });
                }
                map.set(count, showData)
                if (this.setRecordMap) {
                    this.setRecordMap(map)
                }
                // this.setState({ recordMap: map })
            }
            count++
        }
        this.isEnd = true
    }

}